import { connect } from 'react-redux';

import { getDeviceBreakpoint } from '../../service/device';

import CryptocurrencyInstrument from '../../components/instrument/CryptocurrencyInstrument';

import normalizeSymbol from '../../service/normalizesymbol';

function mapStateToProps(state, props) {
    const tickers = state.tickers;

    return {
        ...(tickers[normalizeSymbol(props.symbol)] || {}),
        breakpoint: getDeviceBreakpoint(state.device.windowWidth),
    };
}

export default connect(mapStateToProps)(CryptocurrencyInstrument);



/** WEBPACK FOOTER **
 ** /src/shared/containers/instrument/CryptocurrencyInstrument.js
 **/